import { gql } from "@apollo/client";

export const FETCH_COMPANY_UPLOADS = gql`
  query FetchCompanyUploads($companyId: String!) {
    companyUploads(companyId: $companyId) {
      filename
      displayName
      path
      uploadedAt
      tokenCount
      textPath
    }
  }
`; 